import React from "react";
import { Chip } from "@mui/material";
import GenericCrudPage from "../../components/shared/GenericCrudPage";
import { adminGetPartners, adminCreatePartner, adminUpdatePartner } from "../../api/business";

const PARTNER_TYPE_OPTIONS = [
  { value: "TECHNOLOGY_PARTNER", label: "Technology Partner" },
  { value: "ENTERPRISE_CLIENT", label: "Enterprise Client" },
  { value: "GOVERNMENT", label: "Government" },
];

export default function PartnersPage() {
  return (
    <GenericCrudPage
      title="Partners & Clients"
      queryKey="admin-partners"
      listFn={adminGetPartners}
      createFn={adminCreatePartner}
      updateFn={adminUpdatePartner}
      emptyItem={{ name: "", partner_type: "TECHNOLOGY_PARTNER", logo: "", order_index: 0, is_active: true }}
      columns={[
        { key: "name", label: "Name" },
        { key: "partner_type", label: "Type", render: (r) => <Chip size="small" label={r.partner_type?.replace("_", " ")} /> },
        { key: "order_index", label: "Order" },
        { key: "is_active", label: "Active", render: (r) => (r.is_active ? "Yes" : "No") },
      ]}
      formFields={[
        { name: "name", label: "Name", required: true },
        { name: "partner_type", label: "Type", type: "select", options: PARTNER_TYPE_OPTIONS, required: true },
        { name: "logo", label: "Logo", type: "file" },
        { name: "order_index", label: "Order Index", type: "number" },
        { name: "is_active", label: "Active", type: "switch" },
      ]}
    />
  );
}